
function initSpHome(root){
if(root.dataset.spReady)return;root.dataset.spReady='true';
const content=JSON.parse(root.querySelector('[data-sp-home-text]').textContent);
const chapters=content.chapters;
const cards=root.querySelector('.chapters'),detail=root.querySelector('.story-detail');let previous=null;
if(cards&&detail){root.querySelectorAll('[data-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();previous=b;const d=chapters[Number(b.dataset.open)];cards.hidden=true;detail.hidden=false;root.querySelector('#sp-chapter-kicker').textContent=d.k;root.querySelector('#sp-chapter-heading').textContent=d.h;root.querySelector('#sp-chapter-text').textContent=d.t;root.querySelector('#sp-chapter-link').textContent=d.cta;root.querySelector('#sp-chapter-link').href=['/pages/usm-verkaufen','/pages/dienstleistungen','/collections/all'][Number(b.dataset.open)];root.querySelector('.detail-photo').style.backgroundPosition=d.position;root.querySelector('.detail-photo').style.filter=Number(b.dataset.open)===1?'grayscale(1)':'none';root.querySelectorAll('.chapter').forEach(c=>c.setAttribute('aria-expanded',c.dataset.open===b.dataset.open?'true':'false'));root.querySelector('.back').focus({preventScroll:true});}));
root.querySelector('.back').addEventListener('click',()=>{cards.hidden=false;detail.hidden=true;root.querySelectorAll('.chapter').forEach(c=>c.setAttribute('aria-expanded','false'));if(previous)previous.focus({preventScroll:true});});}
const qualities=content.qualities;
root.querySelectorAll('[data-q]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-q]').forEach(c=>c.setAttribute('aria-pressed',String(c===b)));root.querySelector('.q-detail').textContent=qualities[Number(b.dataset.q)];}));
}
document.querySelectorAll('[data-sp-home]').forEach(initSpHome);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sp-home]').forEach(initSpHome));



function initSpScenes(root){
 if(root.dataset.scenesReady)return;
 root.dataset.scenesReady='true';
 const panels=[...root.querySelectorAll('[data-scene-panel]')];
 const close=root.querySelector('[data-scene-close]');
 const grid=root.querySelector('.sp-scenes-grid');
 const hover=window.matchMedia('(hover: hover) and (pointer: fine)');
 let active=null;
 function show(index){
  active=index;
  root.classList.toggle('sp-scene-expanded',index!==null);
  panels.forEach((panel,i)=>{
   const open=i===index;
   panel.hidden=false;
   panel.classList.toggle('is-active',open);
   panel.querySelector('[data-scene-toggle]').setAttribute('aria-expanded',String(open));
   const cta=panel.querySelector('[data-scene-cta]');if(cta)cta.tabIndex=open?0:-1;
   root.querySelector('[data-scene-copy="'+i+'"]').hidden=!open;
  });
  close.hidden=index===null||hover.matches;
 }
 panels.forEach((panel,i)=>{
  const button=panel.querySelector('[data-scene-toggle]');
  panel.addEventListener('pointerenter',event=>{if(hover.matches&&event.pointerType==='mouse')show(i);});
  panel.addEventListener('focusin',event=>{if(event.target.matches(':focus-visible')||event.target.closest('[data-scene-cta]'))show(i);});
  button.addEventListener('focus',()=>{if(button.matches(':focus-visible'))show(i);});
  button.addEventListener('click',event=>show(hover.matches&&event.detail>0?i:(active===i?null:i)));
 });
 root.addEventListener('pointerleave',event=>{if(hover.matches&&event.pointerType==='mouse'&&!root.contains(document.activeElement))show(null);});
 root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget)&&!root.matches(':hover'))show(null);});
 root.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();show(null);}});
 close.addEventListener('click',()=>show(null));
 show(null);
}
document.querySelectorAll('[data-sp-scenes]').forEach(initSpScenes);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sp-scenes]').forEach(initSpScenes));


function initSpMobileScenes(root){
 if(root.dataset.mobileReady)return;
 root.dataset.mobileReady='true';
 const track=root.querySelector('.sp-mobile-track');
 const slides=[...root.querySelectorAll('[data-mobile-slide]')];
 const selectors=[...root.querySelectorAll('[data-mobile-select]')];
 const captions=[...root.querySelectorAll('[data-mobile-caption]')];
 const mobile=window.matchMedia('(max-width:749px)');
 const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
 const dialog=root.querySelector('dialog');
 let active=0,frame=0,previous=null;
 function sync(index){
  active=Math.max(0,Math.min(slides.length-1,index));
  selectors.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===active)));
  captions.forEach((caption,i)=>caption.hidden=i!==active);
  slides.forEach((slide,i)=>slide.inert=i!==active);
  root.querySelector('[data-mobile-number]').textContent=String(active+1);
 }
 function select(index,animate=true){
  sync(index);
  track.scrollTo({left:active*track.clientWidth,behavior:animate&&!reduced.matches?'smooth':'instant'});
 }
 selectors.forEach((button,i)=>button.addEventListener('click',()=>select(i)));
 track.addEventListener('scroll',()=>{
  if(frame)cancelAnimationFrame(frame);
  frame=requestAnimationFrame(()=>{if(track.clientWidth)sync(Math.round(track.scrollLeft/track.clientWidth));});
 },{passive:true});
 root.addEventListener('keydown',event=>{
  if(event.target.closest('dialog'))return;
  if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
   event.preventDefault();select((active+(event.key==='ArrowRight'?1:slides.length-1))%slides.length);
   selectors[active].focus({preventScroll:true});
  }
 });
 root.querySelectorAll('[data-mobile-enlarge]').forEach(button=>button.addEventListener('click',()=>{
  previous=button;
  const image=button.querySelector('img'),large=dialog.querySelector('img');
  large.src=image.currentSrc||image.src;large.alt=image.alt;
  dialog.showModal();
 }));
 root.querySelector('[data-mobile-dismiss]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
 dialog.addEventListener('close',()=>{if(previous&&mobile.matches)previous.focus({preventScroll:true});});
 function resize(){if(mobile.matches)select(active,false);else if(dialog.open)dialog.close();}
 new ResizeObserver(resize).observe(track);
 mobile.addEventListener('change',resize);
 sync(0);
}
document.querySelectorAll('[data-mobile-scenes]').forEach(initSpMobileScenes);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mobile-scenes]').forEach(initSpMobileScenes));
